import AnalyticsIcon from '@svg/analytics.svg';
import React from 'react';
import styled from 'styled-components';
import { IconButton } from './Button/IconButton';
import { Tooltip } from './Tooltip';
import { VisuallyHidden } from './VisuallyHidden';

const StyledIconButton = styled(IconButton)`
  height: unset;
  padding: 0.25rem;
  margin: 0 0.25rem;
  border-radius: 1rem;

  span.MuiButton-label {
    padding: 0.25rem;
    background-color: ${({ theme }) => theme.colors.blue};
    border-radius: inherit;

    svg {
      width: 0.75rem;
      height: 0.75rem;
      background-color: inherit;
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

export function SyncingToAnalyticsIndicator() {
  return (
    <Tooltip title="Analytics enabled" placement="bottom">
      <StyledIconButton>
        <AnalyticsIcon aria-hidden />
        <VisuallyHidden>Analytics is enabled for this item</VisuallyHidden>
      </StyledIconButton>
    </Tooltip>
  );
}
